import * as React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
/**
 * @ignore - internal component.
 */

export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/internal/svg-icons/Star.js
// module id = 7373
// module chunks = 2